import { render, staticRenderFns } from "./adminDivisionAccess.vue?vue&type=template&id=97837a28"
import script from "./adminDivisionAccess.vue?vue&type=script&lang=js"
export * from "./adminDivisionAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports